import { useEffect, useState } from 'react'

interface ImageSize {
  width: number
  height: number
}

interface UseImageSizeResult {
  dimensions: ImageSize | null
  loading: boolean
}

export const useImageSize = (src: string): UseImageSizeResult => {
  const [dimensions, setDimensions] = useState<ImageSize | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!src) return

    const img = new Image()
    img.src = src
    img.onload = () => {
      setDimensions({ width: img.naturalWidth, height: img.naturalHeight })
      setLoading(false)
    }
  }, [src])

  return { dimensions, loading }
}
